import React from "react";

const TemarioDiplomaturaNutricionDiabetes = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Fisiología y fisiopatología de la diabetes tipo 2"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Objetivos específicos: comprender la fisiopatología de diabetes tipo 2"}</span></li>
                <li><span className="fw-light">{"Bioquímica y metabolismo. Vías metabólicas. Hormonas"}</span></li>
                <li><span className="fw-light">{"Nutrientes presentes en los alimentos: Carbohidratos, proteínas, grasas, vitaminas y minerales"}</span></li>
                <li><span className="fw-light">{"Clasificación"}</span></li>
                <li><span className="fw-light">{"Funciones"}</span></li>
                <li><span className="fw-light">{"Alimentos fuente"}</span></li>
                <li><span className="fw-light">{"Requerimientos y recomendaciones"}</span></li>
                <li><span className="fw-light">{"Etiopatogenia de la diabetes tipo 2"}</span></li>
                <li><span className="fw-light">{"Mecanismos de desarrollo de complicaciones: daño hiperglucémico"}</span></li>
            </ul>
            <br /><br />
            <b>{"Nutrición antiinflamatoria en diabetes tipo 2"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Objetivos específicos: brindar al profesional los conocimientos sobre la prevención de la inflamación metabólica"}</span></li>
                <li><span className="fw-light">{"Aplicando la nutrición como estrategia complementaria al tratamiento del paciente"}</span></li>
                <li><span className="fw-light">{"Nutrición e inflamación metabólica"}</span></li>
                <li><span className="fw-light">{"Estrés oxidativo. Glicación proteica"}</span></li>
                <li><span className="fw-light">{"Fitoquímicos en la nutrición antiinflamatoria"}</span></li>
            </ul>
            <br /><br />
            <b>{"Tratamiento farmacológico de la diabetes tipo 2 y su implicancia nutricional"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Objetivos específicos: establecer los fármacos a utilizar en diabetes tipo 2"}</span></li>
                <li><span className="fw-light">{"Agentes con acción periférica: Inhibidores de Alfa-Glucosidasa, Metformina y Tiazolidindionas, Inhibidores de SGLT2"}</span></li>
                <li><span className="fw-light">{"Agentes insulino-secretagogos: Sulfonilureas, Meglitinidas, Incretinas (Agonistas del Receptor de GLP-1 e inhibidoras de DPP-4)"}</span></li>
                <li><span className="fw-light">{"Insulinas e insulinoterapia"}</span></li>
                <li><span className="fw-light">{"Tipos de insulina"}</span></li>
                <li><span className="fw-light">{"Estrategias de aplicación: instrumentos, sistemas, planes y automanejo de la insulina"}</span></li>
                <li><span className="fw-light">{"Dificultades de la insulinoterapia"}</span></li>
                <li><span className="fw-light">{"Patologías concomitantes a la diabetes tipo 2 y su tratamiento"}</span></li>
            </ul>
            <br /><br />
            <b>{"Planes de alimentación en diabetes tipo 2"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Objetivos específicos: brindar al profesional las herramientas necesarias para realizar una correcta indicación del plan nutricional"}</span></li>
                <li><span className="fw-light">{"Plan de alimentación personalizado. Porciones. Índice glucémico. Hidratos y fibra"}</span></li>
                <li><span className="fw-light">{"Paciente insulinizado y no insulinizado"}</span></li>
                <li><span className="fw-light">{"Tipo de dietas: Dieta vegetariana, Dieta vegana, Dieta cetogénica"}</span></li>
            </ul>
            <br /><br />
            <b>{"Actividad física, sarcopenia y prevención en diabetes tipo 2"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Objetivos específicos: establecer las pautas para la indicación de la actividad física en el paciente con diabetes tipo 2"}</span></li>
                <li><span className="fw-light">{"Fisiología del ejercicio. Adaptación metabólica"}</span></li>
                <li><span className="fw-light">{"Indicación de Macronutrientes y Micronutrientes en el paciente con DBT 2"}</span></li>
                <li><span className="fw-light">{"Composición corporal: masa grasa vs masa muscular"}</span></li>
                <li><span className="fw-light">{"Hidratación: Regulación y necesidades"}</span></li>
                <li><span className="fw-light">{"Sarcopenia. Prevención y tratamiento en el paciente con DBT tipo 2"}</span></li>
            </ul>
            <br /><br />
            <b>{"Complicaciones de la diabetes tipo 2"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Objetivos específicos: analizar las complicaciones de la patología"}</span></li>
                <li><span className="fw-light">{"Emergencias en el paciente con DBT"}</span></li>
                <li><span className="fw-light">{"Cetoacidosis y coma diabético. Hipoglucemia. Coma. Acidosis láctica"}</span></li>
                <li><span className="fw-light">{"Complicaciones a largo plazo. Prevención. Tratamiento"}</span></li>
            </ul>
            <br /><br />
            <b>{"El paciente con diabetes tipo 2 en internación"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"El paciente con diabetes tipo 2 está en internación"}</span></li>
                <li><span className="fw-light">{"Objetivos específicos: comprender"}</span></li>
                <li><span className="fw-light">{"Analizar y establecer las pautas nutricionales a seguir en el paciente en internación con diabetes tipo 2"}</span></li>
                <li><span className="fw-light">{"Introducción"}</span></li>
                <li><span className="fw-light">{"Mecanismos involucrados en el desarrollo de hiperglucemia"}</span></li>
                <li><span className="fw-light">{"Alteraciones asociadas con la hiperglucemia aguda"}</span></li>
                <li><span className="fw-light">{"Actitud frente a la hiperglucemia en la internación. Monitoreo glucémico para el paciente internado"}</span></li>
            </ul>
            <br /><br />
            <b>{"Nutrición para la prevención del envejecimiento"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Objetivos específicos: Definir envejecimiento y establecer la correcta terapéutica nutricional en cada paciente"}</span></li>
                <li><span className="fw-light">{"Brindar herramientas terapéuticas adecuadas a futuro"}</span></li>
                <li><span className="fw-light">{"Definición de envejecimiento"}</span></li>
                <li><span className="fw-light">{"¿Podemos considerar al envejecimiento una enfermedad"}</span></li>
                <li><span className="fw-light">{"Terapéutica nutricional hoy y a futuro en el paciente con DBT tipo 2"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioDiplomaturaNutricionDiabetes;
